import { Box, Typography, Paper } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ASQILogo from '../../assets/logo/ASQILogo.png';

const SatelliteDataReportFooter = () => {
  const { t } = useTranslation();

  return (
    <Paper
      sx={{
        bgcolor: '#4F9767',
        color: 'white',
        px: 2,
        py: 3,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderRadius: 0,
        boxShadow: 0,
        '@media print': {
          padding: '3mm 2mm',
          backgroundColor: '#4F9767 !important',
          color: 'white !important',
          boxShadow: 'none',
          pageBreakInside: 'avoid',
        },
      }}
    >
      <Box sx={{ flex: 1, pr: 2 }}>
        <Typography
          sx={{
            fontSize: '18px',
            fontWeight: '300',
            '@media print': {
              fontSize: '4mm',
            },
          }}
        >
          {t('Disclaimer')}
        </Typography>
        <Typography
          sx={{
            fontSize: '11px',
            fontWeight: '300',
            '@media print': {
              fontSize: '2.5mm',
              lineHeight: '3mm',
            },
          }}
        >
          {t(
            'The insights provided in this Weekly Report Card are generated using satellite data, AI analysis, and other remote sensing technologies. These recommendations, including advice on irrigation, crop growth, yield improvement, and leaf nitrogen estimates, are based on estimated data and models, which may not fully capture on-ground conditions.'
          )}
        </Typography>
        <Typography
          sx={{
            fontSize: '11px',
            fontWeight: '300',
            mt: 1,
            '@media print': {
              fontSize: '2.5mm',
              lineHeight: '3mm',
              marginTop: '1mm',
            },
          }}
        >
          {t(
            'Farmers are advised to use this report as a supplementary tool and validate the recommendations with local agronomists, field observations, and soil tests before making critical agricultural decisions. ASQI and its technology partners are not liable for any losses or variations in yield resulting from the use of this information. For personalized guidance, we recommend consulting with agricultural experts or extension services.'
          )}
        </Typography>
      </Box>
      <Box
        component="img"
        src={ASQILogo}
        alt="Farm App Logo"
        sx={{
          width: 130,
          height: 'auto',
          padding: '8px 16px',
          borderRadius: 1,
          '@media print': {
            width: '25mm',
            padding: '1.5mm 3mm',
          },
        }}
      />
    </Paper>
  );
};

export default SatelliteDataReportFooter;
